import { AbstractQuery } from 'src/models/query';

export type CalendarExportType = 'download' | 'ical';
export type CalendarExportPrivacyStatus = 'keep' | 'toPublic';
export type CalendarExportAppointmentTypeValue = '' | number;

export interface GetAppointmentsForIcsFileQueryOptions {
	activeAppointments: boolean;
	appointmentTypeToExport: CalendarExportAppointmentTypeValue;
	endDate?: string;
	exportType: CalendarExportType;
	informativeAppointments: boolean;
	privacyStatus: CalendarExportPrivacyStatus;
	startDate: string;
}

export class AppointmentQuery extends AbstractQuery {
	name = 'IFS_Calendar_Query_Queries_AppointmentType_GetAppointmentByAppointmentId';
	sort = [];

	constructor(aggregateId: string) {
		super();
		this.parameters.push({ aggregateId: aggregateId });
	}
}

export class ChangeAppointmentTypeOfSubmittedAppointmentId extends AbstractQuery {
	name = 'IFS_Calendar_Query_Queries_AppointmentType_ChangeAppointmentTypeOfSubmittedAppointmentId';
	sort = [];

	constructor(
		previousAppointmentTypeId: number,
		appointmentType: number,
		appointmentId: number,
		additionalUser: number
	) {
		super();
		this.parameters.push({
			previousAppointmentTypeId: previousAppointmentTypeId,
		});
		this.parameters.push({ appointmentType: appointmentType });
		this.parameters.push({ appointmentId: appointmentId });
		this.parameters.push({ additionalUser: additionalUser });
	}
}

export class GetAppointmentTypesWithColorQuery extends AbstractQuery {
	name = 'IFS_Calendar_Query_Queries_AppointmentType_GetAppointmentTypesWithColor';
	sort = [];
	apiVersion = 2;
}

export class GetAppointmentsForIcsFileQuery extends AbstractQuery {
	protected cacheable = false;
	name = 'IFS_Calendar_Query_Queries_AppointmentType_GetAppointmentsForIcsFile';
	sort = [];
	protected subscribeForUpdates = false;

	constructor(options: GetAppointmentsForIcsFileQueryOptions) {
		super();

		const normalizedEndDate =
			options.endDate != null && options.endDate !== '' ? options.endDate : options.startDate;

		this.parameters.push({ startDate: options.startDate });
		this.parameters.push({ endDate: normalizedEndDate });
		this.parameters.push({ exportType: options.exportType });
		this.parameters.push({ activeAppointments: options.activeAppointments });
		this.parameters.push({ informativeAppointments: options.informativeAppointments });
		this.parameters.push({ appointmentTypeToExport: options.appointmentTypeToExport });
		this.parameters.push({ privacyStatus: options.privacyStatus });
	}
}

export class GetRunningAppointmentTimerQuery extends AbstractQuery {
	name = 'IFS_Calendar_Query_Queries_AppointmentType_GetRunningAppointmentTimer';
	sort = [];
	apiVersion = 2;
	subscribeForUpdates = true;
}

export class GetTimerFavoritesQuery extends AbstractQuery {
	name = 'IFS_Calendar_Query_Queries_AppointmentType_GetTimerFavorites';
	sort = [];
	apiVersion = 2;
}
